import { render } from "./RecoverySuccess.vue?vue&type=template&id=a345a982"
import script from "./RecoverySuccess.vue?vue&type=script&lang=js"
export * from "./RecoverySuccess.vue?vue&type=script&lang=js"

import "./RecoverySuccess.vue?vue&type=style&index=0&id=a345a982&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__